import { Component, ElementRef, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

import * as fa from '@fortawesome/free-solid-svg-icons';
import { Organization } from 'src/app/classes/organization';

import { AuthService } from 'src/app/shared/auth.service';
import { environment } from 'src/environments/environment';
import Locales from 'src/app/constants/locales';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  fa = fa
  organizations: Organization[] = []
  environment = environment
  locales = Locales

  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  })

  constructor(
    private router: Router,
    public authService: AuthService,
    @Inject(LOCALE_ID) public activeLocale: string) { }

  ngOnInit(): void {
  }

  language() {
    document.cookie = `admin_lang=${this.activeLocale};max-age=${365 * 24 * 60 * 60};path=/`;
    window.location.href = `/${ environment.base_url ? environment.base_url : '' }${this.activeLocale}`
  }

  login() {
    this.authService.login(this.loginForm.value);
  }
}
